import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
//element.css
import "element-ui/lib/theme-chalk/index.css";
// reset.css
import "assets/style/reset.css";
import VueBus from 'vue-bus'
// import directives from 'common/js/directives'
import "common/js/rem.js";

Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(VueBus)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
